export default __webpack_public_path__ + "static/media/backgroundQr.6fd15df6.png";